<template>
  <div v-loading='loading'>
    <el-button type="success" size="mini" icon="el-icon-download" @click="export_" style="margin-bottom: 20px">导出数据</el-button>
    <el-button type="success" size="mini" icon="el-icon-edit" @click="batch_operaction">批量修改物流商</el-button>
    <el-table 
      v-loading="loading"
      :data="tableData" 
      border 
      :cell-style="{padding:0,borderColor:'#000000'}"
      :header-cell-style="{borderColor:'#000000',color:'#0099ff'}" 
      style="width: 100%;border: 1px solid #000000" 
      :row-style="{height:'100px'}"
      @selection-change="selectionChange"
      @cell-dblclick='DblclickCell'
    >
       <!-- 全选按钮 -->
       <el-table-column
          align="center"
          type="selection"
          label="全选"
          width="40px">
       </el-table-column>

       <!-- 站点 -->
       <!-- <el-table-column prop="site" label="站点" width="110"> </el-table-column> -->

       <!-- 订单状态 -->
       <el-table-column prop="status" label="订单状态" width="90">
           <template slot-scope="scope">
                <el-tag
                :type="scope.row.status === '待付款' ? 'warning' : (scope.row.status === '正在处理' ? 'primary' : (scope.row.status === '已取消' ? 'info' : (scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败订单' ? 'danger' : 'text'))))"
                disable-transitions>
                  {{scope.row.status}}
                </el-tag>
           </template>
       </el-table-column>

       <!-- 订单id -->
       <el-table-column prop="ID_" label="订单ID" width="60px"></el-table-column>

       <!-- 商品id-->
       <el-table-column prop="product_id" label="商品ID" width="140px"></el-table-column>

       <!-- 下单时间 -->
       <el-table-column prop="date_created_gmt" label="下单时间" width="95px"></el-table-column>

       <!-- 付款时间 -->
       <el-table-column prop="date_paid_gmt" label="付款时间" width="95px"></el-table-column>

       <!-- SKU -->
       <!-- <el-table-column prop="sku" label="SKU" width="100px"></el-table-column> -->

       <!-- 国际物流单号 -->
       <el-table-column prop="int_no" label="国际物流单号" width="140px"></el-table-column>

       <!-- 图片 -->
       <el-table-column label="图片" width="50px">
        <template slot-scope="scope">
          <el-popover placement="right" width="500" trigger="click">
            <img :src="scope.row.img" alt="暂无图片" width="500px" height="500px">
            <img :src="scope.row.img" alt="暂无图片" width="30px" height="30px" slot="reference">
          </el-popover>
        </template>
       </el-table-column>

       <!-- 商品名称 -->
      <el-table-column prop="product_name" label="商品名称" width="100px">
      </el-table-column>

      <!-- 定制信息 -->
      <el-table-column label="定制信息">
        <template slot-scope="scope">
          <div><strong style="color:red">尺码:</strong> {{scope.row.size}}</div>
          <div><strong style="color:green">袖标:</strong> {{typeof(scope.row.armband) == 'object' ? '按图' : scope.row.armband}}</div>
          <div><strong style="color:blue">配件:</strong> {{typeof(scope.row.accessories) == 'object' ? '按图' : scope.row.accessories}}</div>
          <div><strong style="color:cyan">字号:</strong> {{scope.row.word_no}}</div>
        </template>
      </el-table-column>

      <!-- 袖标 -->
      <el-table-column label="袖标" width="125">
        <template slot-scope="scope" v-if="typeof(scope.row.armband) == 'object' ? true : false">
          <span v-for="(item,index) in scope.row.armband" :key="index">
              <el-popover placement="left" trigger="click" width="300">
                <img :src="item" width="100%" style="background:gray" />
                <img
                  slot="reference"
                  :src="item"
                  :alt="123"
                  width="48px" height="48px"
                  style="margin:1px;background:gray"
                />
              </el-popover>
            </span>
        </template>
      </el-table-column>

      <!-- 配件 -->
      <el-table-column label="配件" width="125">
        <template slot-scope="scope" v-if="typeof(scope.row.accessories) == 'object' ? true : false">
          <span v-for="(item,index) in scope.row.accessories" :key="index">
              <el-popover placement="left" trigger="click" width="300">
                <img :src="item" width="100%" />
                <img
                  slot="reference"
                  :src="item"
                  :alt="123"
                  width="50px" height="50px"
                />
              </el-popover>
            </span>
        </template>
      </el-table-column>

      <!-- 数量 -->
      <el-table-column prop="quantity" label="数量" width="40px"></el-table-column>

      <!-- 采购价 -->
      <el-table-column v-if="UN == 'cw' ? true: false" label="采购价" width="70px">
        <template slot-scope="scope">
          <span v-if='!scope.row.edit'>{{scope.row.cgj}}</span>
          <el-input size='mini' type='number' ref="CGJ" v-else v-model="scope.row.cgj" @blur='HandleBlur(scope.row)'>{{scope.row.cgj}}</el-input>
        </template>
      </el-table-column>

      <!-- 客户备注 -->
      <el-table-column prop="customer_note" label="客户备注" width="100px"></el-table-column>

      <!-- 商品备注 -->
      <el-table-column label="商品备注" width="100px" :filter-method="filternote" :filters="[{ text: '客服备注', value: '客服备注' }, { text: '仓库备注', value: '仓库备注' }, { text: '物流备注', value: '物流备注' }]">
        <template slot-scope="scope">
          <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.product_note placement="top">
            <el-button type="primary" size="mini" v-show="scope.row.product_note">客服备注</el-button>
          </el-tooltip>
          <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.warehouse_note placement="left">
            <el-button style="margin-left: 0;margin-top: 10px;" type="success" size="mini" v-show="scope.row.warehouse_note">仓库备注</el-button>
          </el-tooltip>
          <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.logistics_note placement="bottom">
            <el-button style="margin-left: 0;margin-top: 10px;" type="warning" size="mini" v-show="scope.row.logistics_note">物流备注</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <!-- <el-table-column label="商品备注" width="100px">
          <template slot-scope="scope">
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.product_note placement="top">
                  <el-button type="primary" size="mini" v-show="scope.row.product_note">客服备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.warehouse_note placement="left">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="success" size="mini" v-show="scope.row.warehouse_note">仓库备注</el-button>
                </el-tooltip>
                <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.logistics_note placement="bottom">
                  <el-button style="margin-left: 0;margin-top: 10px;" type="warning" size="mini" v-show="scope.row.logistics_note">物流备注</el-button>
                </el-tooltip>
              </template>
      </el-table-column> -->

      <!-- 商品状态 -->
      <el-table-column prop="product_status" label="商品状态" width="130px" :filter-method = "filterproduct" :filters="[{text:'待审核', value:'待审核'},{text:'待发货', value:'待发货'},{text:'待发货-制作中', value:'待发货-制作中'},{text:'待处理', value:'待处理'},{text:'未提货', value:'未提货'},{text:'已到货代', value:'已到货代'},{text:'物流已发货', value:'物流已发货'},{text:'异常', value:'异常'},{text:'暂停', value:'暂停'},{text:'已取消', value:'已取消'},{text:'已退款', value:'已退款'},{text:'缺货', value:'缺货'}]">
          <template slot-scope="scope">
            <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.inland_number placement="top">
              <el-button
                :type="scope.row.product_status === '待审核' ? 'danger' : (scope.row.product_status === '待发货' ? 'warning' : (scope.row.product_status === '待发货-制作中' ? 'info' : (scope.row.product_status === '未提货' ? 'success' : (scope.row.product_status === '已到货代' ? 'primary' : (scope.row.product_status === '物流已发货' ? 'success' : (scope.row.product_status === '异常' ? 'danger' : (scope.row.product_status === '暂停' ? 'danger' : (scope.row.product_status === '已取消' ? '' : (scope.row.product_status === '已退款' ? 'warning' : (scope.row.product_status === '缺货' ? 'info' : (scope.row.product_status === '待处理' ? 'info' : '')))))))))))" 
                size="mini">
                {{scope.row.product_status}}
              </el-button>
            </el-tooltip>
          </template>
      </el-table-column>

      <!-- 价格 -->
      <el-table-column prop="price" label="价格" width="70px"></el-table-column>

      <!-- 物流方式 -->
      <el-table-column prop="shiptype" label="物流方式" width="60px"></el-table-column>

      <!-- 物流商 -->
      <el-table-column prop="wls" label="物流商" width="50px" :filter-method = "filterWlS" :filters="[{text:'ST', value:'ST'},{text:'V20', value:'V20'},{text:'66', value:'66'},{text:'WSY', value:'WSY'}]"></el-table-column>

      <!-- 是否加急 -->
      <el-table-column label="是否加急" width="55">
        <template slot-scope="scope">
          <el-radio-group @input='HandleRadio(scope.row)' v-model="scope.row.isurgent">
            <el-radio label="是" style="margin-bottom:10px">是</el-radio>
            <el-radio label="">否</el-radio>
          </el-radio-group>
        </template>
      </el-table-column>

      <!-- 操作 -->
      <el-table-column label="操作" width="50px">
            <template slot-scope="scope">
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="edit(scope.$index, scope.row)"
                    circle
                >
                </el-button>
                <el-button
                    style="margin-left: 0;margin-top: 10px;"
                    type="primary"
                    size="mini"
                    icon="el-icon-view"
                    @click="look(scope.$index, scope.row)"
                    circle
                >
                </el-button>
            </template>
       </el-table-column>
    </el-table>

    <el-dialog title="商品信息" :visible.sync="dialogFormVisible">
        <el-form :model="form">
            <el-form-item label="商品ID" :label-width="formLabelWidth">
            <el-input v-model="form.product_id" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="图片" :label-width="formLabelWidth">
              <el-input v-model="form.img" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="商品名称" :label-width="formLabelWidth">
            <el-input v-model="form.product_name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="客服备注" :label-width="formLabelWidth">
            <el-input v-model="form.product_note" autocomplete="off" placeholder="请输入客服备注"></el-input>
            </el-form-item>
            <el-form-item label="仓库备注" :label-width="formLabelWidth">
            <el-input v-model="form.warehouse_note" autocomplete="off" placeholder="请输入仓库备注"></el-input>
            </el-form-item>
            <el-form-item label="物流备注" :label-width="formLabelWidth">
            <el-input v-model="form.logistics_note" autocomplete="off" placeholder="请输入物流备注"></el-input>
            </el-form-item>
            <el-form-item label="国内快递单号" :label-width="formLabelWidth">
            <el-input :disabled="form.product_status == '仓库已发货' ? false : true" v-model="form.inland_number" autocomplete="off" placeholder="请输入国内快递单号"></el-input>
            </el-form-item>
            <el-form-item label="商品状态" :label-width="formLabelWidth">
                <el-select v-model="form.product_status" placeholder="请选择商品状态">
                    <el-option label="待审核" value="待审核"></el-option>
                    <el-option label="待发货" value="待发货"></el-option>
                    <el-option label="待发货-制作中" value="待发货-制作中"></el-option>
                    <el-option label="待处理" value="待处理"></el-option>
                    <el-option label="未提货" value="未提货"></el-option>
                    <el-option label="已到货代" value="已到货代"></el-option>
                    <el-option label="物流已发货" value="物流已发货"></el-option>
                    <el-option label="异常" value="异常"></el-option>
                    <el-option label="暂停" value="暂停"></el-option>
                    <el-option label="已取消" value="已取消"></el-option>
                    <el-option label="已退款" value="已退款"></el-option>
                    <el-option label="缺货" value="缺货"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="袖标" :label-width="formLabelWidth">
                <el-input v-model="form.armband" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="配件" :label-width="formLabelWidth">
                <el-input v-model="form.accessories" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="字号" :label-width="formLabelWidth">
                <el-input v-model="form.word_no" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="尺码" :label-width="formLabelWidth">
                <el-input v-model="form.size" autocomplete="off"></el-input>
              </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </div>
    </el-dialog>

    <!-- 导出数据二次确认框 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>您确认要导出选中的数据吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpload">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量操作对话框 -->
    <el-dialog title="物流商" :visible.sync="dialog_">
      <el-form :model="form_">
        <el-form-item label="物流商" :label-width="formLabelWidth">
          <el-select v-model="form_.wls" placeholder="请选择物流商">
            <el-option label="ST" value="ST"></el-option>
            <el-option label="V20" value="V20"></el-option>
            <el-option label="66" value="66"></el-option>
            <el-option label="WSY" value="WSY"></el-option>
            <el-option label="HB" value="HB"></el-option>
            <el-option label="XBH" value="XBH"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog_ = false">取 消</el-button>
        <el-button type="primary" @click="QD">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getProduct,Edit,czjl,pilss,plczwls,ckpllrspcgj,ChangeSpeed } from "../../api/api";
import table2excel from 'js-table2excel'
import imageToBase64 from 'image-to-base64/browser';
import { number } from 'echarts';
export default {
  data() {
    return {

      UN:'',

      dialog_:false,
      form_:{
        product_id: [],
        wls: ''
      },

      tableData: [], //订单列表
      loading: true,
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        product_id: '',
        product_name: '',
        product_note: '',
        warehouse_note: '',
        logistics_note: '',
        inland_number: '',
        product_status: ''
      },
      formLabelWidth: '120px',
      data: [],//批量选中的数据(导出或者修改)
      orig:{}
    };
  },
  created() {
    var un = window.localStorage.getItem('un');
    this.UN = un;
    if(un == '' || un == null || un == undefined){
      this.loading = true;
      return false;
    }
    var id_ = this.$route.query.id;
    var pd = this.$route.query.product_id;
    if(id_ != '' && id_ != null && id_ != undefined){
      getProduct(id_).then((res) => {

        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }

          if(i.edit == undefined){
            i.edit = false;
          }

        }

        this.tableData = res;
        this.loading = false;
      });
    }else if(pd != '' && pd != null && pd != undefined){
      var a = pd;
      var b = a.split(',');
      pilss(b).then((res) => {

        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }

          if(i.edit == undefined){
            i.edit = false;
          }

        }

        this.tableData = res;
        this.loading = false;
      })
    }
    
  },
  methods: {

    // 商品备注筛选
    filternote(value, row) {
      if(value == '客服备注'){
        return row.product_note != '' && row.product_note != null;
      }else if(value == '仓库备注'){
        return row.warehouse_note != '' && row.warehouse_note != null;
      }else if(value == '物流备注'){
        return row.logistics_note != '' && row.logistics_note != null;
      }
    },

    // 选择是否加急
    HandleRadio(row){
      var IsUrgent = {
        product_id: row.product_id,
        isurgent: row.isurgent
      }
      // console.log(IsUrgent);
      ChangeSpeed(IsUrgent).then(res => {
        if(res.code == 200){
          this.$message({
            message:res.msg,
            type:'success'
          })
        }else if(res.code == 404){
          this.$message({
            message:res.msg,
            type:'error'
          })
        }
      })
    },

    // 双击单元格显示input输入框
    // DblclickCell(row, column, cell, event){
    DblclickCell(row){
      this.$set(row,'edit',true);
      // input输入框自动获取焦点
      this.$nextTick(() => {
        this.$refs.CGJ.focus();
      })
    },

    // input输入框失去焦点
    HandleBlur(row){
      this.$set(row,'edit',false);
      this.upCgj = {
        cgj:row.cgj,
        product_id:row.product_id
      }
      if(row.cgj == ''){
        this.$message({
          message:'采购价为空,请先输入采购价',
          type:'warning'
        })
        return false
      }
      ckpllrspcgj(this.upCgj).then(res => {
        if(res.code == 200){
          this.$message({
            message:res.msg,
            type:'success'
          })
        }else if(res.code == 404){
          this.$message({
            message:res.msg,
            type:'warning'
          })
        }
      })
    },

    //批量操作(修改物流商)
    batch_operaction(){
      if(window.localStorage.getItem('un') == null || window.localStorage.getItem('un') == '' || window.localStorage.getItem('un') == undefined){
        this.$message({
          message: "账号密码丢失，请重新登录",
          type: "warning",
          showClose: true
        })
        this.loading = true;
        return false;
      }else if(this.data.length == 0){
        this.$message({
          message:'请先选择要操作的商品！！！',
          type:'warning'
        })
      }else{
        this.dialog_ = true;
      }
    },

    // 批量操作(确定)
    QD(){
      this.dialog_ = false;
      // if(window.localStorage.getItem('un') == null || window.localStorage.getItem('un') == '' || window.localStorage.getItem('un') == undefined){
      //   this.$message({
      //     message: "账号密码丢失，请重新登录",
      //     type: "warning",
      //     showClose: true
      //   })
      //   this.loading = true;
      //   return false;
      // };
      for(var i of this.data){
        if(this.form_.wls == '' || this.form_.wls == null || this.form_.wls == undefined){
          this.$message({
            message:'未选择物流商！！！',
            type:'warning'
          })
          return false;
        }else{
          i.wls = this.form_.wls;
          this.form_.product_id.push(i.product_id);
        }
      }
      var params = this.form_;
      plczwls(params).then(res => {});
      this.$message({
        message:'操作成功！！！',
        type:'success'
      })
      var t = new Date();
      var time_ = this.$moment(t.getTime()).format("YYYY-MM-DD HH:mm:ss")
      var lll = this.Data_.length;
      var abc = [];
      for(var i of this.Data_){
        abc.push(i.product_id);
      }
      var nba = abc.toString();
      var name = this.form_.wls;
      // console.log(time_,lll,nba,name);
      var post = {
        person:window.localStorage.getItem('un'),
        time:time_,
        event:'批量操作了' + nba + '共' + lll + '件商品的物流商为' + name + '。'
      }
      czjl(post).then(res => {});
    },

    //全选按钮
    selectionChange(selection){
      for(var k = 0;k < selection.length;k++){
        // if(selection[k].a == undefined){
        //   selection[k].a = '';
        // }
        // if(selection[k].pro_det == undefined){
        //   selection[k].pro_det = `<br/>配件:${selection[k].accessories}<br/>字号:${selection[k].word_no}<br/>尺码:${selection[k].size}<br/>袖标:${selection[k].armband}`;
        // }
        // if(selection[k].customer_note == null){
        //   selection[k].customer_note = '无';
        // }

        // 定制信息
        if(selection[k].pro_det == undefined){
          // selection[k].pro_det = '<br/>配件:' + (typeof(selection[k].accessories) == 'object' ? '按图' : selection[k].accessories) + `<br/>字号:${selection[k].word_no}<br/>尺码:${selection[k].size}<br/>袖标:` + (typeof(selection[k].armband) == 'object' ? '按图' : selection[k].armband);
          var pj = "配件:",zh = "字号:",cm = "尺码:",xb = "袖标:";
          // var zh = "字号:",cm = "尺码:";
          pj = pj.fontcolor('red');
          pj = pj.fontsize(3);
          pj = pj.bold();
          zh = zh.fontcolor('#00ff00');
          zh = zh.fontsize(3);
          zh = zh.bold();
          cm = cm.fontcolor('blue');
          cm = cm.fontsize(3);
          cm = cm.bold();
          xb = xb.fontcolor('cyan');
          xb = xb.fontsize(3);
          xb = xb.bold();
          // selection[k].pro_det = '<br/>配件:' + (typeof(selection[k].accessories) == 'object' ? '按图' : selection[k].accessories) + `<br/>字号:${selection[k].word_no}<br/>尺码:${selection[k].size}<br/>袖标:` + (typeof(selection[k].armband) == 'object' ? '按图' : selection[k].armband);
          selection[k].pro_det = pj + (typeof(selection[k].accessories) == 'object' ? '按图' : selection[k].accessories) + zh + `${selection[k].word_no}` + cm + `${selection[k].size}` + xb + (typeof(selection[k].armband) == 'object' ? '按图' : selection[k].armband);
          // selection[k].pro_det = zh + `${selection[k].word_no}` + cm + `${selection[k].size}`;
        }

        // 格式化支付时间
        // selection[k].date_paid_gmt = this.$moment(selection[k].date_paid_gmt).format('YY-MM-DD');

        // 整合袖标图片
        if(typeof(selection[k].armband) == 'object'){
          // 将袖标字符串转化为数组
          var ddd = selection[k].armband;
          // 袖标数组长度
          var ttt = selection[k].armband.length;
          if(ttt == 0){
            if(selection[k].armband1 == undefined){
              selection[k].armband1 = '无';
            }
            if(selection[k].armband2 == undefined){
              selection[k].armband2 = "无";
            }
            if(selection[k].armband3 == undefined){
              selection[k].armband3 = "无";
            }
            if(selection[k].armband4 == undefined){
              selection[k].armband4 = "无";
            }
            if(selection[k].armband5 == undefined){
              selection[k].armband5 = "无";
            }
            if(selection[k].armband6 == undefined){
              selection[k].armband6 = "无";
            }
          }
          else if(ttt == 1){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = "无";
                }
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = "无";
                }
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = "无";
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }
            }
          }
          else if(ttt == 2){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = "无";
                }
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = "无";
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 3){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = "无";
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 4){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }else if(i == 3){
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 5){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }else if(i == 3){
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = ddd[i];
                }
              }else if(i == 4){
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 6){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }else if(i == 3){
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = ddd[i];
                }
              }else if(i == 4){
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = ddd[i];
                }
              }else if(i == 5){
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = ddd[i];
                }
              }
            }
          }
        }

        // 整合配件图片
        if(typeof(selection[k].accessories) == 'object'){
          var sss = selection[k].accessories;
          var ggg = selection[k].accessories.length;
          if(ggg == 0){
            if(selection[k].accessories1 == undefined){
              selection[k].accessories1 = '无';
            }
            if(selection[k].accessories2 == undefined){
              selection[k].accessories2 = '无';
            }
          }
          else if(ggg == 1){
            for(var p = 0;p < ggg;p++){
              if(p == 0){
                if(selection[k].accessories1 == undefined){
                  selection[k].accessories1 = sss[p];
                }
                if(selection[k].accessories2 == undefined){
                  selection[k].accessories2 = '无';
                }
              }
            }
          }
          else if(ggg == 2){
            for(var p = 0;p < ggg;p++){
              if(p == 0){
                if(selection[k].accessories1 == undefined){
                  selection[k].accessories1 = sss[p];
                }
              }else if(p == 1){
                if(selection[k].accessories2 == undefined){
                  selection[k].accessories2 = sss[p];
                }
              }
            }
          }
        }

      }

      for(let i of this.data){
        imageToBase64(i.img).then((response) => 
          {
            // console.log('data:image/jpeg;base64,' + response);
            i.img = 'data:image/jpeg;base64,' + response
          }).catch((error) => 
          {
            console.log(error);
          })
      }

      this.data = selection;

    },

    // X(导出数据)
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },

    //导出数据(二次确认)
    export_(){
      if(window.localStorage.getItem('un') == null || window.localStorage.getItem('un') == '' || window.localStorage.getItem('un') == undefined){
        this.$message({
          message: "账号密码丢失，请重新登录",
          type: "warning",
          showClose: true
        })
        this.loading = true;
        return false;
      };
      this.dialogVisible = true;
    },

    //导出数据(确认导出)
    handleUpload(){
      this.dialogVisible = false;
      // if(window.localStorage.getItem('un') == null || window.localStorage.getItem('un') == '' || window.localStorage.getItem('un') == undefined){
      //   this.$message({
      //     message: "账号密码丢失，请重新登录",
      //     type: "warning",
      //     showClose: true
      //   })
      //   this.loading = true;
      //   return false;
      // };
      if(this.data.length == 0){
        this.$message({
          message: "导出数据为空,请先选中您要导出的数据",
          type: "warning",
          showClose: true
        })
        return false;
      }else{
        for(var i = 0;i < this.data.length;i++){
          this.data[i].date_created_gmt = this.$moment(this.data[i].date_created_gmt).format('YY-MM-DD');
          this.data[i].date_paid_gmt = this.$moment(this.data[i].date_paid_gmt).format('YY-MM-DD');
          this.data[i].int_no = '&nbsp;' + this.data[i].int_no;
        }
      }
      if(window.localStorage.getItem('un') == 'cw'){
        let column = [
          {
            title: '订单状态',
            key: 'status',
            type: 'text'
          },
          {
            title: '订单ID',
            key: 'ID_',
            type: 'text'
          },
          {
            title: '站点',
            key: 'site',
            type: 'text'
          },
          {
            title: '商品id',
            key: 'product_id',
            type: 'text'
          },
          {
            title: '付款时间',
            key: 'date_paid_gmt',
            type: 'text'
          },
          {
            title: '国际物流单号',
            key: 'int_no',
            type: 'text'
          },
          {
            title: '产品图片',
            key: 'img',
            type: 'image',
            width: 120,
            height: 110
          },
          {
            title: '产品名称',
            key: 'product_name',
            type: 'text'
          },
          {
            title: '定制信息',
            key: 'pro_det',
            type: 'text'
          },
          {
            title: '袖标1',
            key: 'armband1',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标2',
            key: 'armband2',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标3',
            key: 'armband3',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标4',
            key: 'armband4',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标5',
            key: 'armband5',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标6',
            key: 'armband6',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '配件1',
            key: 'accessories1',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '配件2',
            key: 'accessories2',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '数量',
            key: 'quantity',
            type: 'text'
          },
          {
            title: '采购价',
            key: 'cgj',
            type: 'text'
          },
          {
            title: '客服备注',
            key: 'product_note',
            type: 'text',
          },
          {
            title: '仓库备注',
            key: 'warehouse_note',
            type: 'text',
          },
          {
            title: '物流备注',
            key: 'logistics_note',
            type: 'text',
          },
          {
            title: '商品状态',
            key: 'product_status',
            type: 'text'
          },
          {
            title: '价格',
            key: 'price',
            type: 'text'
          },
          {
            title: '物流方式',
            key: 'shiptype',
            type: 'text'
          },
          {
            title: '物流商',
            key: 'wls',
            type: 'text'
          },
          {
            title: '是否加急',
            key: 'isurgent',
            type: 'text'
          },
        ]
        table2excel(column, this.data, "订单列表.xls");
      }else{
        let column = [
          {
            title: '站点',
            key: 'site',
            type: 'text'
          },
          {
            title: '商品id',
            key: 'product_id',
            type: 'text'
          },
          {
            title: '订单id', 
            key: 'ID_',
            type: 'text'
          },
          {
            title: '支付时间', 
            key: 'date_paid_gmt',
            type: 'text'
          },
          {
            title: '产品图片',
            key: 'img',
            type: 'image',
            width: 120,
            height: 110
          },
          {
            title: '产品名称',
            key: 'product_name',
            type: 'text'
          },
          {
            title: '定制信息',
            key: 'pro_det',
            type: 'text'
          },
          {
            title: '袖标1',
            key: 'armband1',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标2',
            key: 'armband2',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标3',
            key: 'armband3',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标4',
            key: 'armband4',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标5',
            key: 'armband5',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '袖标6',
            key: 'armband6',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '配件1',
            key: 'accessories1',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '配件2',
            key: 'accessories2',
            type: 'image',
            width: 80,
            height: 80
          },
          {
            title: '客户备注',
            key: 'customer_note',
            type: 'text'
          },
          {
            title: '数量',
            key: 'quantity',
            type: 'text'
          },
          {
            title: '物流商',
            key: 'wls',
            type: 'text'
          },
          {
            title: '客服备注',
            key: 'product_note',
            type: 'text',
          },
          {
            title: '仓库备注',
            key: 'warehouse_note',
            type: 'text',
          },
          {
            title: '物流备注',
            key: 'logistics_note',
            type: 'text',
          },
          {
            title: '商品状态',
            key: 'product_status',
            type: 'text'
          },
          {
            title: '国际物流单号',
            key: 'int_no',
            type: 'text'
          }
        ]
        table2excel(column, this.data, "订单列表.xls");
      }
      // var abc = [];
      // for(var i of this.data){
      //   i.product_status = "待发货-制作中";
      //   abc.push(i.product_id);
      // }
      // var params = {
      //   "product_id":abc,
      //   "product_status":"待发货-制作中"
      // };
      // DC(params).then(res => {});
      var t = new Date();
      var time_ = this.$moment(t.getTime()).format("YYYY-MM-DD HH:mm:ss")
      var lll = this.data.length;
      var abc = [];
      for(var i of this.data){
        abc.push(i.product_id);
      }
      var nba = abc.toString();
      var params = {
        person:window.localStorage.getItem('un'),
        time:time_,
        event:'导出了' + nba + '共' + lll + '件商品。'
      }
      czjl(params).then(res => {});
    },

    //编辑
    edit(index,row){
      if(window.localStorage.getItem('un') == null || window.localStorage.getItem('un') == '' || window.localStorage.getItem('un') == undefined){
        this.$message({
          message: "账号密码丢失，请重新登录",
          type: "warning",
          showClose: true
        })
        this.loading = true;
        return false;
      };

      this.form = {
        product_id: row.product_id,
        img: row.img,
        product_name: row.product_name,
        product_note: row.product_note,
        warehouse_note: row.warehouse_note,
        logistics_note: row.logistics_note,
        inland_number: row.inland_number,
        product_status: row.product_status,
        armband: row.armband,
        accessories: row.accessories,
        word_no: row.word_no,
        size: row.size
      }
      this.dialogFormVisible = true;
      getProduct(this.form.product_id).then(res => {
        // console.log(res);
        this.orig = res[0];
      })
    },

    //取消编辑
    cancel(){
        this.dialogFormVisible = false;
        this.$message('取消编辑成功！！！');
    },

    //确定编辑
    confirm(){
        // console.log(this.form.inland_number);
        // if((this.form.inland_number == '' || this.form.inland_number == undefined) && this.form.product_status == "仓库已发货"){
        if((this.form.inland_number == '' || this.form.inland_number == undefined) && this.form.product_status == "TMD"){
            this.$message({
                message:'仓库已发货时，国内快递单号不能为空！！！',
                type:'error'
            })
            return false;
        }else{
          var timee = new Date();
          var timeee = this.$moment(timee.getTime()).format("YYYY-MM-DD HH:mm:ss");
          var params = {
            product_id: this.form.product_id,
            img: this.form.img,
            product_name: this.form.product_name,
            product_note:this.form.product_note,
            warehouse_note:this.form.warehouse_note,
            logistics_note:this.form.logistics_note,
            inland_number:this.form.inland_number,
            product_status:this.form.product_status,
            armband:this.form.armband,
            accessories:this.form.accessories,
            word_no:this.form.word_no,
            size:this.form.size,
            person:window.localStorage.getItem('un'),
            time:timeee
          };
          Edit(params).then(res => {
            if(res.code === 200){
              this.loading = true;
              for(var i of this.tableData){
                if(i.product_id == this.form.product_id){
                  i.img = this.form.img;
                  i.product_name = this.form.product_name;
                  i.product_note = this.form.product_note;
                  i.warehouse_note = this.form.warehouse_note;
                  i.logistics_note = this.form.logistics_note;
                  i.inland_number = this.form.inland_number;
                  i.product_status = this.form.product_status;
                  i.armband = this.form.armband;
                  i.accessories = this.form.accessories;
                  i.word_no = this.form.word_no;
                  i.size = this.form.size;
                }
              }
              this.loading = false;
              this.$message({
                message: '编辑成功！！！',
                type: 'success'
              });

              // var t = new Date();
              // var time_ = this.$moment(t.getTime()).format("YYYY-MM-DD HH:mm:ss");
              // var ah = false;
              // if(this.orig.img != params.img || this.orig.product_name != params.product_name || this.orig.product_note != params.product_note || this.orig.warehouse_note != params.warehouse_note || this.orig.logistics_note != params.logistics_note || this.orig.product_status != params.product_status || this.orig.armband != params.armband || this.orig.accessories != params.accessories || this.orig.word_no != params.word_no || this.orig.size != params.size){
              //   var speak = '将' + this.orig.product_id + '的';
              //   ah = true;
              // }

              // // 1
              // if(this.orig.img != params.img){
              //   speak += '图片由' + this.orig.img + '改为' + params.img;
              // }
              // // 2
              // if(this.orig.product_name != params.product_name){
              //   speak += '商品名称由' + this.orig.product_name + '改为' + params.product_name;
              // }
              // // 3
              // if(this.orig.product_note != params.product_note){
              //   speak += '客服备注由' + this.orig.product_note + '改为' + params.product_note;
              // }
              // // 4
              // if(this.orig.warehouse_note != params.warehouse_note){
              //   speak += '仓库备注由' + this.orig.warehouse_note + '改为' + params.warehouse_note;
              // }
              // // 5
              // if(this.orig.logistics_note != params.logistics_note){
              //   speak += '物流备注由' + this.orig.logistics_note + '改为' + params.logistics_note;
              // }
              // // 6
              // if(this.orig.product_status != params.product_status){
              //   speak += '商品状态由' + this.orig.product_status + '改为' + params.product_status;
              // }
              // // 7
              // if(this.orig.armband != params.armband){
              //   speak += '袖标由' + this.orig.armband + '改为' + params.armband;
              // }
              // // 8
              // if(this.orig.accessories != params.accessories){
              //   speak += '配件由' + this.orig.accessories + '改为' + params.accessories;
              // }
              // // 9
              // if(this.orig.word_no != params.word_no){
              //   speak += '字号由' + this.orig.word_no + '改为' + params.word_no;
              // }
              // // 10
              // if(this.orig.size != params.size){
              //   speak += '尺码由' + this.orig.size + '改为' + params.size;
              // }
              // if(ah == true){
              //   var post = {
              //     person:window.localStorage.getItem('un'),
              //     time:time_,
              //     event:speak
              //   }
              //   console.log(post);
              //   czjl(post).then(res => {});
              // }

            }else{
              this.$message({
                message: '编辑失败！！！',
                type: 'error'
              });
            }
          }).catch((error) => {
            console.log(error);
          });
          this.dialogFormVisible = false;
        }
        // // this.reload();
    },

    //查看详情
    look(index, row){
        const routeData = this.$router.resolve({ path: "/home/Orderdetail_", query: { site: row.site, ID_: row.ID_ } });
        window.open(routeData.href, '_blank');
    },

    // 物流商筛选
    filterWlS(value, row){
      return row.wls === value;
    },

    // 商品状态筛选
    filterproduct(value, row){
      return row.product_status === value;
    },
  },
};
</script>

<style lang="scss" scoped>
  // 隐藏数字输入框后面的上下调节按钮
  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    appearance: none !important;
  }
  /deep/ input[type="number"] {
    -moz-appearance: textfield !important;
    appearance: textfield !important;
  }
</style>